var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoundOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7492 41.8172H24.2628L41.4067 55.6291C41.7036 55.8691 42.0775 56 42.4514 56C42.6933 56 42.9353 55.9454 43.1552 55.8363C43.727 55.5636 44.1009 54.9854 44.1009 54.3635V47.4576L50.0612 54.8436C50.3911 55.2472 50.8639 55.4545 51.3478 55.4545C51.7107 55.4545 52.0736 55.3345 52.3815 55.0945C53.0963 54.5272 53.2062 53.5016 52.6344 52.7925L44.1009 42.21V9.63318C44.1009 9.01132 43.749 8.44401 43.1882 8.17126C42.6274 7.89852 41.9566 7.95307 41.4617 8.324L26.0113 19.8012L17.4228 9.15315C16.862 8.45492 15.8173 8.33491 15.1135 8.90222C14.3987 9.46953 14.2777 10.4951 14.8496 11.2042L22.8222 21.0885H12.7492C11.2316 21.0885 10 22.3104 10 23.816V39.0897C10 40.5953 11.2316 41.8172 12.7492 41.8172Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOff);
export default __webpack_public_path__ + "static/media/sound_off.27644a16.svg";
export { ForwardRef as ReactComponent };